module.exports = __webpack_public_path__ + "static/media/login-background480.f113c072.jpg";